module.exports = __webpack_public_path__ + "static/media/PAGF24-Black.4ff7d52c.svg";